import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 添加代理商
export function addAgent(req) {
  return request({
    url: apiConfig.addAgent.api.add.url,
    method: "post",
    data: {
      agentName: req.agentName,
      agentCode: req.agentCode,
      contactName: req.contactName,
      contactPhone: req.contactPhone,
      email: req.email,
      website: req.website,
      businessDirection: req.businessDirection,
      scope: req.scope,
      projectSpecialty: req.projectSpecialty,
      about: req.about,
      remarks: req.remarks
    }
  });
}
